/** `/c/$companyId/journals` — manual journals, filtered by state. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DRAFT_STATES, DraftsScreen } from "../journals/DraftsScreen";

const search = z.object({ state: z.enum(DRAFT_STATES).catch("ALL") });

export const Route = createFileRoute("/_auth/c/$companyId/journals/")({
  validateSearch: (raw) => search.parse(raw),
  component: Journals,
});

function Journals(): JSX.Element {
  const { companyId } = Route.useParams();
  const { state } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DraftsScreen
      companyId={companyId}
      state={state}
      onState={(next) => void navigate({ search: { state: next }, replace: true })}
    />
  );
}
